__turbopack_context__.v({
  "active": "style-module-scss-module__NDE4qG__active",
  "content-card": "style-module-scss-module__NDE4qG__content-card",
  "data-disclaimer": "style-module-scss-module__NDE4qG__data-disclaimer",
  "heading-chevron": "style-module-scss-module__NDE4qG__heading-chevron",
  "heading-dropdown-layer": "style-module-scss-module__NDE4qG__heading-dropdown-layer",
  "heading-location": "style-module-scss-module__NDE4qG__heading-location",
  "heading-text": "style-module-scss-module__NDE4qG__heading-text",
  "local-focus-page": "style-module-scss-module__NDE4qG__local-focus-page",
  "no-location-content": "style-module-scss-module__NDE4qG__no-location-content",
  "no-location-heading": "style-module-scss-module__NDE4qG__no-location-heading",
  "no-location-subtext": "style-module-scss-module__NDE4qG__no-location-subtext",
  "page-content": "style-module-scss-module__NDE4qG__page-content",
  "pill": "style-module-scss-module__NDE4qG__pill",
  "pill-row": "style-module-scss-module__NDE4qG__pill-row",
  "pill-sm": "style-module-scss-module__NDE4qG__pill-sm",
  "reveal-left": "style-module-scss-module__NDE4qG__reveal-left",
  "reveal-right": "style-module-scss-module__NDE4qG__reveal-right",
  "reveal-scale": "style-module-scss-module__NDE4qG__reveal-scale",
  "reveal-up": "style-module-scss-module__NDE4qG__reveal-up",
  "revealed": "style-module-scss-module__NDE4qG__revealed",
  "section": "style-module-scss-module__NDE4qG__section",
  "section-heading": "style-module-scss-module__NDE4qG__section-heading",
  "stagger-container": "style-module-scss-module__NDE4qG__stagger-container",
  "stagger-revealed": "style-module-scss-module__NDE4qG__stagger-revealed",
});
